import { render, staticRenderFns } from "./shenhe.vue?vue&type=template&id=5665f184&scoped=true"
import script from "./shenhe.vue?vue&type=script&lang=js"
export * from "./shenhe.vue?vue&type=script&lang=js"
import style0 from "./shenhe.vue?vue&type=style&index=0&id=5665f184&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5665f184",
  null
  
)

export default component.exports